import { Button } from "../components/Button";
import { useFlow } from "../flow/FlowContext";
import { useT } from "../i18n";

export function AboutYouScreen() {
  const { answers, setAboutYou, next, canContinue } = useFlow();
  const t = useT();

  return (
    <>
      <div className="prompt screen-enter">
        <header className="screen-head">
          <div className="screen-head__eyebrow">{t("about.eyebrow")}</div>
          <h1 className="screen-head__title">{t("about.title")}</h1>
          <p className="screen-head__text">{t("about.text")}</p>
        </header>
        <label className="field">
          <span className="sr-only">{t("about.label")}</span>
          <textarea
            className="field__textarea"
            rows={6}
            maxLength={800}
            placeholder={t("about.placeholder")}
            value={answers.aboutYou}
            onChange={(e) => setAboutYou(e.target.value)}
          />
        </label>
      </div>
      <div className="shell__footer" style={{ paddingLeft: 0, paddingRight: 0 }}>
        <Button onClick={next} disabled={!canContinue}>
          {t("common.next")}
        </Button>
      </div>
    </>
  );
}
